import React, { useEffect } from 'react'
import LikeImage from 'images/like.png';
import LikeEmptyImage from 'images/like-empty.png';
import PublishImage from 'images/publish.png';
import PublishEmptyImage from 'images/publish-empty.png';
import { withErrorBoundary, GoogleStaticMap } from 'shared';
import { SmartButton } from 'ui/smart-buttons';
import { eventHours, eventDate, eventDateTitle } from './EventHelper';
import OccurrenceRow from './OccurrenceRow';
import EventReservationBlock from './EventReservationBlock';
import { MissingImage } from 'customizations';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import ParkImageSlider from '../parks/ParkImageSlider';

const EventModal = (props) => {
  // State

  // Consts

  // Hooks
  useEffect(() => {
    let { event } = props;
    if (event && event.isEvent) event.track();
  }, [])

  // Custom Methods

  const renderBody = () => {
    let { event, smartButtons, reloadSmartButtons, base, subroute } = props;
    return (
      <div className="modal-body">
        <button className="close-modal" onClick={props.onClose}>&times;</button>
        <div className="left-pane">
          <div className="card event-title-card">
            <div className="titlebar-actions">
              {event.isEventlike && App.user && App.user.regular && (
                <>
                  <span className="modal-titlebar-action" onClick={() => event.like()}>
                    <img src={event.isLiked ? LikeEmptyImage : LikeImage} alt={event.isLiked ? "Unlike icon" : "Like icon"} />
                    <span className="text event-information-light">{event.view_count}</span>
                  </span>
                  {event.isRegular && (
                    <span className="modal-titlebar-action follower-action" onClick={() => event.publish()}>
                      <img src={event.isPublished ? PublishEmptyImage : PublishImage} alt={event.isPublished ? "Unpublish icon" : "Publish icon"} />
                      <span className="follower-text event-information-light">Push to Followers</span>
                    </span>
                  )}
                </>
              )}
            </div>
            <h3 className="event-name">{event.name}</h3>
            <ParkImageSlider images={event.image_urls} fallbackImage={MissingImage} />
          </div>

          <div className="card event-info">
            <h1 className="section-title event-information mb-0">Event Information</h1>
            <h2 className="section-title event-information">{event.sub_title}</h2>
            <div className="event-description event-information-detail">
              {event.note && <p>{event.note}</p>}
              <div dangerouslySetInnerHTML={{ __html: event.description }}></div>
            </div>
          </div>
        </div>

        <div className="card right-pane right-card">
          <div className="card event-date-map">
            <div className="event-date-section">
              <FontAwesomeIcon icon={faCalendarAlt} className="calendar-icon" />
              <div className="event-entity-date event-information-detail" title={eventDateTitle(event)}>{eventDate(event, 'longest')}</div>
              <div className="event-entity-time event-information-light" title={eventDateTitle(event)}>{eventHours(event)}</div>
            </div>
          </div>
          {((subroute || '').startsWith('reserve') || (renderRightPane() && React.isValidElement(renderRightPane()) &&
            React.Children.toArray(renderRightPane().props.children).some(child =>
              React.isValidElement(child) ? React.Children.toArray(child.props.children).length > 0 : (typeof child === 'string' && child.trim() !== '')
            )
          )) && (
          <div className="card event-buttons">
            <div className="right-pane">
              {
                (subroute || '').match(/^(reserve|modifyReservation)/) ?
                <EventReservationBlock {...{ event, base, subroute, reloadSmartButtons }}  action={subroute.startsWith('reserve') ? 'reserve' : 'modifyReservation'}
                /> : renderRightPane()
              }
            </div>
          </div>
          )}
          {event.showMap && (
            <div className="card event-map">
              <div className="entity-map">
                <GoogleStaticMap defaultZoom={15} defaultCenter={event.coords} address={event.address} />
              </div>
              <div className="left-pane-text-content">
                <div className="entity-address event-information-light">
                  <a href={event.address_map_url} className="text-ligher" target="_blank">{event.address}</a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  const renderOccurrences = () => {
    let { event, base } = props;
    return (
      <div className="event-occurrence-list">
        <h1 className="visually-hidden">
          Event Occurrence Table
        </h1>
        {event.hasOccurrences ? (
          <table className="event-occurrence-table">
            <tbody>
              {event.occurrenceObjects.map(occurrence => (
                <OccurrenceRow key={occurrence.id} {...{ event, occurrence, base }} />
              ))}
            </tbody>
          </table>
        ) : (
          <div>Will not occur any time soon.</div>
        )}
      </div>
    );
  }

  const renderRightPane = () => {
    let { event } = props
    return (
      <div className='event-base-info'>
        {event.isEnrollmentPending &&
          <div className="alert alert-warning text-center">
            Enrollment request submitted
          </div>
        }
        {event.occurrences && renderOccurrences()}
        {(event.isEventlike || event.isParkReservation) && renderSmartButtons()}
      </div>
    )
  }

  const renderSmartButtons = () => {
    let { event, smartButtons, reloadSmartButtons, base } = props;
    return (
      <ul className="smart-buttons event-smart-buttons" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {smartButtons &&
          smartButtons.map(smartButton => (
            <li key={smartButton.key} style={{ display: 'inline-block', marginRight: '0.5rem' }}>
              <SmartButton
                {...{ smartButton, reloadSmartButtons, base }}
                object={event}
                returnPath={application.path}
              />
            </li>
          ))
        }
      </ul>
    );
  }

  // Render
  return <div className="EventModal custom-modal"> { renderBody() } </div>
}

export default SmartButton.containerComponent('event', withErrorBoundary(EventModal));
